import { ICookiesProvider, SagaContextKey } from "@gamedev-web/gamedev-sdk-core";

import type { PartnerConfigManager } from "../../../partners";

export const createSagaContext = (
  cookiesProvider: ICookiesProvider,
  sessionProvider: CookieSessionInterfaces.CookieSessionObject | null | undefined,
  partnerConfigManager: PartnerConfigManager
) => ({
  [SagaContextKey.cookies]: cookiesProvider,
  [SagaContextKey.session]: sessionProvider,
  [SagaContextKey.partners]: partnerConfigManager,
});
